import React, { useState, useEffect, useRef, Fragment } from "react";
import { useStore, useDispatch, useSelector } from 'react-redux'
// reactstrap components
import {
  Button,
  Card,
  CardText,
  CardTitle,
  CardImg,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";



// core components
import LandingNavbar from "../../components/Navbars/LandingNavbar.js";
import TransparentFooter from "../../components/Footers/TransparentFooter.js";
import { login, getUserProfile} from "../../actions"
import swal from 'sweetalert'

function LoginPage(props) {
  const dispatch = useDispatch()
  const [firstFocus, setFirstFocus] = useState(false);
  const [lastFocus, setLastFocus] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState(localStorage.getItem("access-token"))
  const [isAdmin, setIsAdmin] = useState(false)
  const [isUser, setIsUser] = useState(false)
  const [logedInState, setLogedInState] = useState(false)
  const [profile,setUserProfile] = useState({});
  const {
    adminGetProfile: userProfile,
  
  } = useSelector((state) => state);
  
  useEffect(() => {
    setToken(localStorage.getItem("access-token"))
  })

  useEffect(() => {
    const keyDownHandler = event => {
     

      if (event.key === 'Enter') {
        event.preventDefault();

        // 👇️ call submit function here

        _onLogin();
      }
    };
    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [username,password]);

  useEffect(() => {
   
      if (userProfile.data && !userProfile.isLoading && !userProfile.isFailed) {
        setUserProfile(userProfile.data);
      }
  }, [userProfile]);

  useEffect(() => {
    if (token) {
      dispatch(getUserProfile()).then(res => {

        if (!res) {
          setIsAdmin(false)
          setIsUser(false);
          localStorage.clear()
          setToken(localStorage.getItem("access-token"))
        }
      })
     
    }
  }, [token])

  useEffect(() => {
    document.body.classList.add("login-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("login-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  useEffect(() => {
    if(isAdmin) {
      props.history.push('/profile-page')
    }else  if(isUser) {
      props.history.push('/user-page')
    }
  }, [isAdmin,isUser])

  useEffect(() => {
    if(profile && token) {
      if(profile.person_type == 1){
        setIsUser(true);
      }else{
      
        setIsAdmin(true)
      }
      setLogedInState(false);
    }
  }, [profile])

 
  const _onLogin = () => {
    setLogedInState(true);
    login(username, password).then(res => {
       
        if (res.status==200) {
            setToken(localStorage.getItem("access-token"))
        }else if(res.status==401){
          setIsAdmin(false)
          setIsUser(false)
          swal({
            title: "ไม่มีสิทธิ์เข้าใช้ระบบ!",
            text: "กรุณาติดต่อผู้ดูแลระบบ หากต้องการเข้าใช้งาน",
            icon: "warning",
            button: "ตกลง",
            dangerMode: true
          })
          localStorage.clear()
          setToken(localStorage.getItem("access-token"))
          setLogedInState(false)
        }
        else {
          setIsAdmin(false)
          setIsUser(false)
          swal({
            title: "ข้อมูลไม่ถูกต้อง!",
            text: "โปรดตรวจสอบข้อมูล",
            icon: "warning",
            button: "ตกลง",
            dangerMode: true
          })
          localStorage.clear()
          setToken(localStorage.getItem("access-token"))
          setLogedInState(false)
        }
    
    })
  }

  const _onLogout = async () => {
    await localStorage.clear()
    await setToken(localStorage.getItem("access-token"))
    await setIsAdmin(false)
    await setIsUser(false);
  }

  return (
    <>
      <LandingNavbar token={token} logout={() => _onLogout()} onPage='login' />
      <div className="page-header clear-filter" filter-color="blue">
        {!token && <div className="content">
          <Container>
            <Col className="ml-auto mr-auto" md="4">
              <Card className="card-login card-plain">
                <Form action="" className="form" method="">
                  <CardHeader className="text-center">
                    <img
                      alt="..."
                      className=""
                      src={require("assets/img/msu_chat_logo.png")}
                      style={{ height: '120px' }}
                    ></img>
                  </CardHeader>
                  <CardBody>
                    <InputGroup
                      className={
                        "no-border input-lg" +
                        (firstFocus ? " input-group-focus" : "")
                      }
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="now-ui-icons users_single-02"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="User Name..."
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        onFocus={() => setFirstFocus(true)}
                        onBlur={() => setFirstFocus(false)}
                      ></Input>
                    </InputGroup>
                    <InputGroup
                      className={
                        "no-border input-lg" +
                        (lastFocus ? " input-group-focus" : "")
                      }
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="now-ui-icons objects_key-25"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Password..."
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onFocus={() => setLastFocus(true)}
                        onBlur={() => setLastFocus(false)}
                      ></Input>
                    </InputGroup>
                  </CardBody>
                  <CardFooter className="text-center">
                    { !logedInState && 
                      <Button
                        block
                        className="btn-round"
                        color="info"
                        onClick={() => _onLogin()}
                        size="lg"
                      >
                        Login
                      </Button>
                    }
                    {
                      logedInState &&  <span>กำลังตรวจสอบข้อมูลผู้เข้าใช้ระบบ</span>
                    }
                  </CardFooter>
                </Form>
              </Card>
            </Col>
          </Container>
        </div>}
        <TransparentFooter />

      </div>
    </>
  );
}

export default LoginPage;
